export { default } from "./CreateAssessment.gql";
